import React from "react";
import style from "./index.module.scss";
import {
    CourseItem,
    date2Week,
    getPlatformName,
    isTrue,
    workState
} from "../../../../../../service/service";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import Config from "config";
import BadgeCor from "../BadgeCor";
import Storage from "../../../../../../utils/Storage";
import { stopJump } from "../../../../../../utils/common";
import classNames from "classnames";

interface DayCellProps {
    course?: CourseItem;
    showMore?: boolean;
    type?: "home" | "my";
}

export default function DayCell({
    course,
    type = "home",
    showMore = true
}: DayCellProps) {
    const history = useHistory();

    if (!course)
        return (
            <div
                className={classNames(style.root, {
                    [style.my]: type === "my"
                })}
            />
        );

    const {
        channelId,
        courseNo,
        courseSeq,
        week,
        date,
        section,
        continunity,
        weekTimeId,
        courseUrl,
        isOpen,
        platformType
    } = course;

    async function gotoLive(url: string, channelId: string) {
        const batchNo = Storage.get("batch") || Config.DefaultBatch;
        return stopJump(
            `${url}?courseNo=${courseNo}&courseSeq=${courseSeq}&batchNo=${batchNo}&customerCode=${Config.CustomCode}&channelId=${channelId}`,
            null
        );
    }

    const menu = (
        <Menu style={{ width: "100px", padding: "0px", textAlign: "center" }}>
            <Menu.Item
                className={style.menu}
                onClick={() => gotoLive(Config.LiveUrl, channelId)}>
                网页直播
            </Menu.Item>
            <Menu.Item
                className={style.menu}
                onClick={() => gotoLive(Config.LiveUrlClient, channelId)}>
                客户端直播
            </Menu.Item>
        </Menu>
    );

    function isHasThirdParty() {
        return isTrue(isOpen) && platformType !== "1";
    }

    function itemClickHandler(e: React.MouseEvent<HTMLElement>) {
        const target = e.target as HTMLElement;
        if (target.tagName === "A") return;
        if (!course) return;
        history.push(`/course/detail/${course?.weekTimeId}`);
    }

    return (
        <div
            className={classNames(style.root, {
                [style.my]: type === "my"
            })}>
            <div className={style.wrapper} onClick={itemClickHandler}>
                {type === "home" && (
                    <div className={style.courseName}>{course?.courseName}</div>
                )}

                <div
                    className={classNames(style.container, {
                        [style.containerMy]: type === "my"
                    })}>
                    {type === "home" && (
                        <>
                            <div className={style.courseNo}>
                                编号： {course?.courseNo}
                            </div>
                            <div className={style.courseOrder}>
                                序号： {course.courseSeq}
                            </div>
                        </>
                    )}

                    <div className={style.address}>地点： {course.address}</div>

                    <div className={style.timeRange}>
                        {course.beginTime} ~ {course.endTime}
                    </div>
                </div>

                {type === "home" && (
                    <BadgeCor
                        timeDate={date}
                        beginTime={course.beginTime}
                        endTime={course.endTime}
                    />
                )}
            </div>

            {showMore && (
                <div className={style.footer}>
                    {course.workstate !== workState.NoHomework && (
                        <Link
                            to={`/homework/review/list/${courseNo}/${courseSeq}/${week}/${date2Week(
                                date
                            )}/${section}/${continunity}/${weekTimeId}`}
                            className={style.homework}>
                            批作业
                        </Link>
                    )}
                    {course.workstate === workState.NoHomework && (
                        <Link
                            to={`/homework/edit/${courseNo}/${courseSeq}/${week}/${date2Week(
                                date
                            )}/${section}/${continunity}/${weekTimeId}`}
                            className={style.homework}>
                            留作业
                        </Link>
                    )}

                    <div>
                        {isHasThirdParty() && (
                            <a href={courseUrl} className={style.live}>
                                {getPlatformName(platformType)}
                            </a>
                        )}
                        {/*{!isHasThirdParty() && (*/}
                        {/*    <Dropdown*/}
                        {/*        overlay={menu}*/}
                        {/*        className={style.live}*/}
                        {/*        placement="bottomCenter">*/}
                        {/*        <a>*/}
                        {/*            直播 <Icon type="down" />*/}
                        {/*        </a>*/}
                        {/*    </Dropdown>*/}
                        {/*)}*/}
                    </div>
                </div>
            )}
        </div>
    );
}
